module.exports = __webpack_public_path__ + "static/flags/AZ-34426b7ec4d53fbc780b1337f8f3ea5c.gif";